import {SocketDataTypes} from '../../../../shared/SocketDataTypes'
import {ArrayUtils} from '../../../../shared/utils/ArrayUtils'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController'
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UITopNotificationView} from './UITopNotificationView'
import {throttleUserAction} from '../../../shared/scripts/ui_utils/ClientUtils'
import {TranslationObject} from '@colonist/i18n'

export class UITopNotificationController {
    private static readonly gameIds: string[] = []
    private static readonly rejectedGameIds: string[] = []
    private static readonly views: UITopNotificationView[] = []

    static show(text: TranslationObject, type: UITopNotificationType, buttonText?: TranslationObject, action?: () => void, removeAction?: () => void, showCloseButton: boolean = true, duration?: number) {
        this.views.push(new UITopNotificationView(text, type, buttonText, action, removeAction, showCloseButton, duration))
    }

    static showGames(games: SocketDataTypes.UserGamesData[]) {
        for(const game of games) {
            if(this.gameIds.includes(game.id)) continue
            if(this.rejectedGameIds.includes(game.id)) continue
            this.gameIds.push(game.id)

            const disconnectTranslation: TranslationObject = game.disconnected ? {
                key: 'strings:homePage.notifications.disconnectedFromGame',
                options: {
                    context: UIUtilsEjsVariables.isUserOnDiscord ? 'discord' : undefined,
                    playerCount: game.playerCount,
                    gameId: UIUtilsEjsVariables.isUserOnDiscord ? undefined : game.id,
                },
            } : {
                key: 'strings:homePage.notifications.activeGame',
                options: {
                    context: UIUtilsEjsVariables.isUserOnDiscord ? 'discord' : undefined,
                    playerCount: game.playerCount,
                    gameId: UIUtilsEjsVariables.isUserOnDiscord ? undefined : game.id,
                },
            }

            this.show(disconnectTranslation, UITopNotificationType.Reconnect, {key: 'strings:homePage.notifications.reconnect'}, throttleUserAction(() => {
                SocketLobbySend.reconnectGame(game.id, CA.Label.ClickedReconnectGame)
            }), () => {
                ArrayUtils.removeElementFromArray(this.gameIds, game.id)
                this.rejectedGameIds.push(game.id)
            })
        }
    }

    static removeDisconnectBanners() {
        this.removeBanners(UITopNotificationType.Reconnect)
    }

    static removeSocketErrorBanners() {
        this.removeBanners(UITopNotificationType.SocketError)
    }

    private static removeBanners(type: UITopNotificationType) {
        for(const view of this.views) {
            if(view.type != type) continue
            view.hide()
            ArrayUtils.removeElementFromArray(this.views, view)
        }
    }
}
